import './Spinner.css';

const Spinner = () => {
  return (
    <>
    <div className="spinner-container">
      <div className="spinner"></div>
      <h1>Loading...</h1>
    </div>
    </>

  );
}

export default Spinner;